import React from "react";
import { Card } from "react-bootstrap";

const AboutCard = ({ image, title, contents, readMore, showReadMore = true, className = "" }) => {
  const cardImageStyle = {
    height: "180px",
    // width:"240px",
    // objectFit: "cover",
    // borderRadius: "0.75rem 0.75rem 0 0",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "#198754",
    fontWeight: "500",
    fontSize:"15px",
    cursor: "pointer",
  };

  return (
    <div className={`my-3 ${className}`}>
      <div >
        <Card.Img variant="top" src={image} alt={title} style={cardImageStyle} />
        {/* <Card.Body>
          <Card.Title className="fs-5 fw-bold" style={{color:"#9f5a06ff"}}>{title}</Card.Title>
          <Card.Text className="text-muted" style={{ fontSize: "0.95rem" }}>
            {contents}
          </Card.Text>
          {showReadMore && (
            <Card.Link style={linkStyle} onClick={readMore}>
              Read More
            </Card.Link>
          )}
        </Card.Body> */}
      </div>
    </div>
  );
};

export default AboutCard;
